import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ISignUpPayload } from "src/app/models/auth/sign-up-payload";
import { AuthService } from "src/app/services/auth.service";

const DEFAULT_SIGN_UP_ERROR_MESSAGE = "Something went wrong, please try again";

const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,30}$/;

@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.scss"],
})
export class SignUpComponent implements OnInit {
  readonly passwordErrorMessage =
    "'Password' must be between 8 and 30 characters where at least one upper case, one lower case letters and one special symbol";

  form: UntypedFormGroup;
  isPasswordVisible = false;
  isRepeatPasswordVisible = false;
  isSignUpError = false;
  signUpErrorMessage = DEFAULT_SIGN_UP_ERROR_MESSAGE;

  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  async register() {
    this.isSignUpError = false;

    const signUpPayload: ISignUpPayload = {
      login: this.form.get("login").value,
      email: this.form.get("email").value,
      password: this.form.get("password").value,
    };

    await this._authService
      .signUp(signUpPayload)
      .then(() => this.navigateToVerifyEmail(signUpPayload.email))
      .catch((error: HttpErrorResponse) => this.showSignUpError(error));
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleRepeatPasswordVisibility() {
    this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
  }

  private navigateToVerifyEmail(email: string) {
    this._router.navigate(["/auth/verify-email"], { state: { email } });
  }

  private showSignUpError(error: HttpErrorResponse) {
    this.signUpErrorMessage = error?.error?.errors?.[0] ?? DEFAULT_SIGN_UP_ERROR_MESSAGE;
    this.isSignUpError = true;
  }

  private static passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get("password")?.value;
    const repeatPassword = control.get("repeatPassword")?.value;

    return password === repeatPassword ? null : { passwordsMismatch: true };
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup(
      {
        login: new UntypedFormControl("", [Validators.required, Validators.minLength(4)]),
        email: new UntypedFormControl("", [Validators.required, Validators.email]),
        password: new UntypedFormControl("", [Validators.required, Validators.pattern(PASSWORD_PATTERN)]),
        repeatPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(8)]),
        agreedToTerms: new UntypedFormControl(false, [Validators.requiredTrue]),
      },
      { validators: SignUpComponent.passwordsMatchValidator },
    );
  }
}
